import { render, staticRenderFns } from "./create-feecolumn.vue?vue&type=template&id=108c80b6&scoped=true"
import script from "./create-feecolumn.vue?vue&type=script&lang=js"
export * from "./create-feecolumn.vue?vue&type=script&lang=js"
import style0 from "./create-feecolumn.vue?vue&type=style&index=0&id=108c80b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108c80b6",
  null
  
)

export default component.exports